import React from 'react';
import BossApprovalDashboard from '../components/Purchases/BossApprovalDashboard';

const BossApprovalPage: React.FC = () => {
    return <BossApprovalDashboard />;
};

export default BossApprovalPage;
